import { InputAdornment, TextField } from '@mui/material';
import React, { useCallback, useState } from 'react';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { IconClear } from '../../../base/icons/svg';
import { IconSearchParticipant } from '../../../moderator-controller/components/ModeratorControllerIcons';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { setFilterDisplayname } from '../../actions.any';
const Search = ({ placeholder, iconSearch, autoFocus }) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState('');
    const handleSearch = useCallback(_.debounce((value) => {
        dispatch(setFilterDisplayname(value));
    }), [500]);
    return (React.createElement(TextField, { sx: { width: 320 }, autoFocus: Boolean(autoFocus), size: 'small', placeholder: placeholder, value: value, onChange: (e) => {
            setValue(e.target.value);
            handleSearch(e.target.value);
        }, InputProps: {
            startAdornment: (React.createElement(InputAdornment, { position: 'start' }, iconSearch ?? React.createElement(IconSearchParticipant, null))),
            endAdornment: (React.createElement(React.Fragment, null, value.length > 0 &&
                React.createElement(InputAdornment, { position: 'end' },
                    React.createElement(ClickableIcon, { accessibilityLabel: 'clear-input', icon: IconClear, onClick: () => {
                            setValue('');
                            handleSearch('');
                        }, className: 'icon-input', onKeyPress: (e) => {
                            if (e?.key === 'Enter') {
                                setValue('');
                                handleSearch('');
                            }
                        } }))))
        } }));
};
export default Search;
